import {getAbsoluteUrl} from "../../utils/urlUtill";

export function EmployeeDetailService($log, $http) {

    this.getEmployee = (employeeId) => $http({method: 'GET', url: getAbsoluteUrl('employee/' + employeeId)});

    this.getEmployeeStatisticsConfiguration = (employeeId) => $http({
        method: 'GET',
        url: getAbsoluteUrl('employee/' + employeeId + '/statistics-configuration')
    });

    this.updateEmployeeStatisticsStatus = (employeeId, statisticsId, status) => $http({
        method: 'PUT',
        url: getAbsoluteUrl(`employee/config/status`),
        data: {
            employeeId: employeeId,
            statisticsId: statisticsId,
            status: status
        }
    });

    this.getLeadCampaigns = (employeeId) => $http({
        method: 'GET',
        url: getAbsoluteUrl('employee/' + employeeId + '/lead-campaign')
    });

    this.save = (employee) => $http({
        method: 'POST',
        url: getAbsoluteUrl('employee/save'),
        data: employee
    });

}